import useReactRouterBreadcrumbs from "use-react-router-breadcrumbs";
import { routeConfig } from "../../../routes";

const useBreadCrumbs = () => {
  const breadCrumbs = useReactRouterBreadcrumbs(routeConfig(), {
    excludePaths: [
      "/",
      "/properties/:propertyId/asset",
      "/projects/:projectId/asset",
      "/properties/:propertyId/calendar",
      "/projects/:projectId/calendar",
      "*/profile/:currentTabIndex",
      "/sops/:sopId",
      "/sops/:sopId/version-:versionId",
      "/profile/contacts/:companyId",
      "/approve_time/:userId",
      "/approve_time/card/:userId/:date",
      "/approve_time/card/:userId",
      "/timecard_history/:timesheetId",
      "/timeoff",
      "/myprofile",
      "/myprofile/:userId",
    ],
  });
  return {
    breadCrumbs,
  };
};

export default useBreadCrumbs;
